import { Component, Input } from '@angular/core';
import { CommonFunctionalitiesService } from '@app/services/common-functionalities.service';

@Component({
  selector: 'app-type-specific-status',
  templateUrl: './type-specific-status.component.html',
  styleUrls: ['./type-specific-status.component.scss']
})
export class TypeSpecificStatusComponent {

  /****************** Variable declaration ******************/
  className: string | undefined;

  /****************** Input and Output decorators ******************/
  @Input() specifiedType: string | undefined;
  @Input() statusName!: string;
  @Input() type!: boolean;

  /**
   * Constructor
   * @param cf 
   */
  constructor(private cf: CommonFunctionalitiesService) {}

  /**
   *
   * @returns Retrieves class name
   */
  getClassname() {
    if (['success', 'Active', 'active', 'pass', 'complete', 'completed', 'true', 'Codemeter', 'SonarQube'].includes(this.statusName)) {
      return !this.type ? "rt-rounded  alert-success" : "right-rounded  alert-success"
    } else if (['fail', 'failed', 'cancelled'].includes(this.statusName)) {
      return !this.type ? "rt-rounded  alert-danger" : "right-rounded  alert-danger"
    } else if (['running', 'inprogress', 'in_progress'].includes(this.statusName)) {
      return !this.type ? "rt-rounded  alert-inprogress" : "right-rounded  alert-inprogress"
    } else if (['aborted', 'queued'].includes(this.statusName)) {
      return !this.type ? "rt-rounded  alert-warning" : "right-rounded  alert-warning"
    } else if (['Inactive', 'false'].includes(this.statusName)) {
      return !this.type ? "rt-rounded  alert-secondary" : "right-rounded  alert-secondary"
    } else if (['system_abort', 'github_abort'].includes(this.statusName)) {
      return !this.type ? "rt-rounded  alert-secondary" : "right-rounded  alert-secondary"
    } else if (['dispatched'].includes(this.statusName)) {
      return !this.type ? "rt-rounded  alert-info" : "right-rounded alert-info"
    } else {
      return !this.type ? "rt-rounded  alert-primary" : "right-rounded  alert-primary"
    }
    return '';
  }

  /**
   * Function is used to format status name for removing underscore and change the status name
   * to sentence case
   * @param statusName 
   * @returns 
   */
  formatStatusName(statusName: string): string {
    let formattedName = statusName.replace(/_/g, ' ');
    // Capitalize the first letter of the first word
    formattedName = formattedName.charAt(0).toUpperCase() + formattedName.slice(1).toLowerCase();
    
    const replacements: { [key: string]: string } = {
      'True': 'Active',
      'False': 'Inactive'
    };
    if (replacements.hasOwnProperty(formattedName)) {
      return replacements[formattedName];
    }
    return this.cf.formatString(formattedName);
  }
}

enum StatusColors {
  success = "alert-success",
  pass = "alert-success",
  fail = "alert-danger",
  failed = "alert-danger",
  inactive = "alert-warning",
  new = "alert-secondary",
  queued = "alert-secondary",
  abort = "alert-secondary",
  active = "alert-success",
  complete = "alert-success",
  running = "alert-success",
  inprogress = "alert-success"
};
